<template>
  <div class="detail">
    <!-- <div class="cover" v-if="isPc"></div> -->
    <iframe :src="url" frameborder="0"  id="outerPage" sandbox="allow-forms allow-scripts allow-same-origin">
    </iframe>
    <!-- <iframe :src="url" frameborder="0"  id="outerPage" >
    </iframe> -->
    <!-- <div class="cover-bot"></div> -->
  </div>
</template>

<script>
// import list from '../util/list';//快看
// import list from '../util/txlist';//腾讯
// import list from '../util/wblist';//微博
// import list from '../util/mmlist';//漫漫
import list from '../util/qrlist';//奇热
// import list from '../util/yqlist';//瑛麒


import _isMobile from '../util/util'
export default {
  data() {
    return {
      url: '',
    }
  },
  created() {
    list.forEach((item, index) => {
      if (item.id == this.$route.query.id) {
        // if (_isMobile()) {
          this.url = item.mobileLink
          // alert("手机端");
        // } else {
        //   // alert("pc端");
        //   this.isPc = true
        //   this.url = item.pcLink
        // }
      }
    })
  },
}
</script>

<style lang="scss" scoped>
body {
  position: relative;
}

.detail {
  width: 100%;
  height: 100vh;
  position: relative;

  .cover-bot {
    height: 2.3rem;
    width: 99%;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #fff;
  }


  iframe {
    width: 100%;
    height: 100vh;
  }

}
</style>